import { Component } from 'react';
import { connect } from 'react-redux';

import { addCartItem } from 'redux/cart/actions';

import AddToCartButton from './AddToCartButton';
import ErrorMessage from './ErrorMessage';
import GiftCardItemData from './GiftCardItemData';
import Price from './Price';
import VariantSelector from './VariantSelector';

class AddToCartGiftCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: null,
      giftMessage: null,
      errorMessage: null,
      selectedVariant: props.product.variants[0]
    };
  }

  submitForm = (e) => {
    const { props, state } = this;
    e.preventDefault();
    const { selectedVariant } = this.state;
    // validate all data in events
    let errorMessage;
    if (!state.email || state.email === '') {
      errorMessage = 'Recipient Email Required';
    }
    if (errorMessage) {
      this.setState({ errorMessage });
      return;
    }

    const item = {
      quantity: 1,
      sku: selectedVariant.sku,
      itemData: {
        recipients: [{ email: state.email, giftMessage: state.giftMessage }]
      }
    };
    this.setState({ errorMessage: null });
    props.addCartItem(item, props.analytics);
  };

  handleEmailChange = (email) => {
    this.setState({ email, errorMessage: null });
  };

  handleGiftMessageChange = (giftMessage) => {
    this.setState({ giftMessage, errorMessage: null });
  };

  handleVariantChange = (variantId) => {
    const { props } = this;
    const selectedVariant = props.product.variants.find(
      (variant) => variant.id === variantId
    );
    this.setState({ selectedVariant });
  };

  render() {
    const { product, hidePrice, settings, showVariantTitle } = this.props;
    const { selectedVariant, errorMessage, email, giftMessage } = this.state;
    return (
      <form
        action=""
        onSubmit={this.submitForm}
        className="c7-product__variant"
      >
        <Price
          variant={selectedVariant}
          hidePrice={hidePrice}
          settings={settings}
          showVariantTitle={showVariantTitle}
        />
        <VariantSelector
          product={product}
          selectedVariant={selectedVariant}
          settings={settings}
          onVariantChange={this.handleVariantChange}
        />
        <ErrorMessage errorMessage={errorMessage} />
        <>
          <div className="c7-product__variant__add-to-cart">
            Quantity:&nbsp;&nbsp;
            <label htmlFor="quantity">
              <input
                type="text"
                name="quantity"
                value="1"
                disabled
                aria-label={`Quantity for ${product.title}`}
              />
            </label>
          </div>
          <div>
            <GiftCardItemData
              email={email}
              giftMessage={giftMessage}
              onEmailChange={this.handleEmailChange}
              onGiftMessageChange={this.handleGiftMessageChange}
            />
          </div>
          <div className="c7-product__variant__add-to-cart">
            <AddToCartButton product={product} settings={settings} />
          </div>
        </>
      </form>
    );
  }
}

export default connect(null, { addCartItem })(AddToCartGiftCard);
